const body = qs('body')

/* Swiper Initialiser */
const swiperContainerP = document.getElementsByClassName('carousel_product')
for (var i = 0; i < swiperContainerP.length; i++) {
	swiperContainerP[i].classList.add('swiperP' + i)

	const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination')

	if (swiperPage) {
		swiperPage.classList.add('pageP' + i)
	}

	var mySwiperP = new Swiper('.swiperP' + i, {
		direction: 'horizontal', 
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		speed: 300,
		centeredSlides: true,
		pagination: {
			el: '.pageP' + i,
			clickable: true
		}
	})
}

let reveals = qsa('.reveal')

function showReveals() {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1
	})
}

if (reveals.length > 0) {
	showReveals()
}

/* Open Cart */

const detailLinks = qsa(
	'details a:not([data-ajax-cart-request-button]), details label, details button:not([data-ajax-cart-request-button])'
)

detailLinks.forEach((link) => {
	link.addEventListener('click', (e) => {
		e.stopPropagation()
	})
})

/* Details Animator */
const details = document.querySelectorAll('details')

if (details) {
	details.forEach((targetDetail) => {
		if (targetDetail.hasAttribute('data-mobile-menu-accordion')) return
		if (targetDetail.classList.contains('cart-item__frequency')) return // has its own animated close below

		targetDetail.addEventListener('toggle', function (e) {
			if (e.newState == 'closed') {
				e.preventDefault()
				targetDetail.classList.add('closing')
				setTimeout(() => {
					targetDetail.removeAttribute('open')
					targetDetail.classList.remove('closing')
				}, 390)
			}
		})
	})
}

/* Cart Frequency Dropdown - animated close + close on outside click (delegated so it survives ajax re-renders) */
const FREQUENCY_CLOSE_MS = 300 // keep in sync with the .cart-item__frequency-menu animation duration

const closeFrequencyDropdown = (dropdown) => {
	if (dropdown.classList.contains('is-closing')) return
	dropdown.classList.add('is-closing')
	setTimeout(() => {
		dropdown.removeAttribute('open')
		dropdown.classList.remove('is-closing')
	}, FREQUENCY_CLOSE_MS)
}

document.addEventListener('click', (e) => {
	const toggle = e.target.closest('.cart-item__frequency-toggle')
	const current = toggle ? toggle.parentElement : null

	// Clicking the toggle of an open dropdown: run the out-animation before <details> actually closes
	if (current && current.hasAttribute('open')) {
		e.preventDefault()
		closeFrequencyDropdown(current)
	}

	qsa('.cart-item__frequency[open]').forEach((dropdown) => {
		if (dropdown !== current && !dropdown.contains(e.target)) {
			closeFrequencyDropdown(dropdown)
		}
	})
})

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({
	threshold: 600,
})

/* Cart Recommendations */

const initRecommendationTriggers = () => {
	const triggers = qsa('[data-recommended-modal-trigger]')
	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault()
			const id = trigger.dataset.recommendedModalTrigger

			const modal = qs(`[data-recommended-modal="${id}"]`)

			if (modal) {
				modal.classList.add('active')
			}
		})
	})
}

const initRecommendationModals = () => {
	const modals = qsa('[data-recommended-modal]')

	modals.forEach((modal) => {
		const toggles = qsa('[data-recommended-modal-close]', modal)
		toggles.forEach((toggle) => {
			toggle.addEventListener('click', (e) => {
				e.preventDefault()
				modal.classList.remove('active')
			})
		})
		document.addEventListener('keydown', (e) => {
			if (e.key !== 'Escape') return
			if (modal.classList.contains('active')) {
				modal.classList.remove('active')
			}
		})
	})
}

const initCartRecommendations = () => {
	initRecommendationTriggers()
	initRecommendationModals()
}

initCartRecommendations()

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	subscribeToResult((state) => {
		initCartRecommendations()
	})
	//todo reattach recommended cart listeners here

	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''
		let quickAddText = ''

		const btn = form.querySelector('button[type="submit"]')
		const quickAddTextEl = btn?.querySelector('.quick-add__text')

		if (quickAddTextEl) {
			quickAddText = quickAddTextEl.textContent
			quickAddTextEl.textContent = window.variantStrings.adding
		} else if (btn) {
			btnInner = btn.innerHTML
			btn.innerHTML = window.variantStrings.adding
		}

		subscribeToResult((state) => {
			const btn = form.querySelector('button[type="submit"]')
			const quickAddTextEl = btn?.querySelector('.quick-add__text')

			if (state.responseData.ok) {
				cartOpen()
				const stickyAtc = qs('[data-product-sticky-atc]')
				if (stickyAtc) stickyAtc.classList.remove('active')
			}

			if (btn) {
				setTimeout(() => {
					if (quickAddTextEl) {
						quickAddTextEl.textContent = quickAddText
					} else {
						btn.innerHTML = btnInner
					}
				}, 300)
			}
		})
	}
})


/* Header */

const header = qs('#header')

const megaMenuToggles = qsa('[data-mega-menu-toggle]', header)
const megaMenuClose = qs('[data-mega-menu-close]', header)
const megaMenu = qs('[data-mega-menu]', header)

// The mega menu renders with .is-deferred (display: none) so its lazy images stay out of
// the initial load. Reveal on window load or first open, whichever comes first.
function revealMegaMenu() {
	if (!megaMenu || !megaMenu.classList.contains('is-deferred')) return
	megaMenu.classList.remove('is-deferred')
	// Force a style flush so the opacity transition still runs if this is the first open
	void megaMenu.offsetWidth
}

if (document.readyState === 'complete') {
	revealMegaMenu()
} else {
	window.addEventListener('load', revealMegaMenu, { once: true })
}

function closeMegaMenu() {
	header.classList.remove('is-mega-menu-open')
	qsa('[data-mega-menu-panel].active', header).forEach((panel) => {
		panel.classList.remove('active', 'is-opening')
	})
	qsa('[data-mega-menu-toggle].active', header).forEach((toggle) => {
		toggle.classList.remove('active')
		toggle.setAttribute('aria-expanded', 'false')
	})
}

function switchMegaMenu(toggle, panelId) {
	const panel = qs(`[data-mega-menu-panel="${panelId}"]`, header)
	if (!panel || toggle.classList.contains('active')) return

	const wasOpen = header.classList.contains('is-mega-menu-open')

	revealMegaMenu()

	qsa('[data-mega-menu-panel].active', header).forEach((activePanel) => {
		activePanel.classList.remove('active', 'is-opening')
	})
	qsa('[data-mega-menu-toggle].active', header).forEach((activeToggle) => {
		activeToggle.classList.remove('active')
		activeToggle.setAttribute('aria-expanded', 'false')
	})

	header.classList.add('is-mega-menu-open')
	toggle.classList.add('active')
	toggle.setAttribute('aria-expanded', 'true')
	panel.classList.add('active')

	if (!wasOpen) {
		panel.classList.add('is-opening')
	}
}

megaMenuToggles.forEach((toggle) => {
	toggle.addEventListener('mouseenter', () => {
		switchMegaMenu(toggle, toggle.dataset.megaMenuToggle)
	})
})

header.addEventListener('mouseleave', closeMegaMenu)

// const headerInner = qs('.header__inner', header)
// if (headerInner) {
// 	headerInner.addEventListener('mouseenter', closeMegaMenu)
// }

if (megaMenuClose) {
	megaMenuClose.addEventListener('click', closeMegaMenu)
	megaMenuClose.addEventListener('mouseenter', closeMegaMenu)
}

/* Mobile Menu Drawer */

const mobileMenuDrawer = qs('[data-mobile-menu-drawer]', header)
const mobileMenuToggles = qsa('[data-mobile-menu-toggle]', header)
const mobileMenuCloses = qsa('[data-mobile-menu-close]', header)

function closeMobileMenu() {
	body.classList.remove('js-mobile-menu-open')
	mobileMenuToggles.forEach((toggle) => {
		toggle.setAttribute('aria-expanded', 'false')
	})
	if (mobileMenuDrawer) {
		mobileMenuDrawer.setAttribute('aria-hidden', 'true')
	}
}

function openMobileMenu() {
	closeMegaMenu()
	body.classList.add('js-mobile-menu-open')
	mobileMenuToggles.forEach((toggle) => {
		toggle.setAttribute('aria-expanded', 'true')
	})
	if (mobileMenuDrawer) {
		mobileMenuDrawer.setAttribute('aria-hidden', 'false')
	}
}

function toggleMobileMenu() {
	if (body.classList.contains('js-mobile-menu-open')) {
		closeMobileMenu()
	} else {
		openMobileMenu()
	}
}

mobileMenuToggles.forEach((toggle) => {
	toggle.addEventListener('click', toggleMobileMenu)
})

mobileMenuCloses.forEach((btn) => {
	btn.addEventListener('click', closeMobileMenu)
})

document.addEventListener('keydown', (e) => {
	if (e.key !== 'Escape') return
	if (!body.classList.contains('js-mobile-menu-open')) return
	closeMobileMenu()
})

/* Mobile Menu Accordions */

const mobileMenuAccordions = mobileMenuDrawer
	? qsa('[data-mobile-menu-accordion]', mobileMenuDrawer)
	: []

function closeMobileMenuAccordion(accordion) {
	const panel = qs('.mobile__menu-accorddion-panel', accordion)
	if (!panel || accordion.classList.contains('is-closing')) return

	accordion.classList.add('is-closing')

	const onTransitionEnd = (e) => {
		if (e.target !== panel || e.propertyName !== 'grid-template-rows') return
		panel.removeEventListener('transitionend', onTransitionEnd)
		accordion.removeAttribute('open')
		accordion.classList.remove('is-closing')
	}

	panel.addEventListener('transitionend', onTransitionEnd)
}

function openMobileMenuAccordion(accordion) {
	accordion.classList.remove('is-closing')
	accordion.setAttribute('open', '')
}

mobileMenuAccordions.forEach((accordion) => {
	const summary = qs('summary', accordion)
	if (!summary) return

	summary.addEventListener('click', (e) => {
		e.preventDefault()

		if (accordion.hasAttribute('open')) {
			closeMobileMenuAccordion(accordion)
			return
		}

		openMobileMenuAccordion(accordion)
	})
})

const announcementElements = {
	el: qs('#announcementBar'),
	closeButtons: qsa('[data-announcement-close]')
}
const announcementStorageKey = 'goodlids-announcement-hidden'

const setHeaderOffset = () => {
	const announcementHeight =
		announcementElements.el?.classList.contains('active')
			? announcementElements.el.offsetHeight
			: 0
	const headerHeight = header?.offsetHeight || 0
	document.documentElement.style.setProperty(
		'--headerHeight',
		`${announcementHeight + headerHeight}px`
	)
}

;(() => {
	const closed = sessionStorage.getItem(announcementStorageKey)

	if (!closed && announcementElements.el) {
		announcementElements.el.classList.add('active')
	}

	setHeaderOffset()
})()

window.addEventListener('resize', setHeaderOffset)

announcementElements.closeButtons.forEach((closeButton) => {
	closeButton.addEventListener('click', (e) => {
		e.preventDefault()
		announcementElements.el.classList.remove('active')
		sessionStorage.setItem(announcementStorageKey, true)
		setHeaderOffset()
	})
})
/* Search Modal */

const searchButtonDesktop = qs('#desktopSearchModalToggle')
const searchModalDesktop = qs('#searchModal')
const searchDesktopToggles = qsa('[data-search-toggle]')

searchDesktopToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		const isOpen = searchModalDesktop.classList.contains('active')

		if (isOpen) {
			searchModalDesktop.classList.remove('active')
			searchButtonDesktop.setAttribute('aria-expanded', 'false')
		} else {
			searchModalDesktop.classList.add('active')
			searchButtonDesktop.setAttribute('aria-expanded', 'true')
		}
	})
})

/* Homepage Hero */

const homepageHeroSections = qsa('[data-homepage-hero]')

homepageHeroSections.forEach((section) => {
	const heroEls = {
		pagination: qs('[data-homepage-hero-pagination]', section)
	}
	const duration = section.dataset.homepageHero

	const swiper = new Swiper(section, {
		slidesPerView: 1,
		height: 'auto',
		speed: 600,
		keyboard: {
			enabled: true,
			onlyInViewport: false
		},
		pagination: {
			el: heroEls.pagination,
			type: 'bullets'
		},
		autoplay: {
			delay: duration,
			clickable: true
		}
	})
})


function initMobileLinksCarousel(root = document) {
	qsa('[data-mobile-links-carousel]', root).forEach((carouselEl) => {
		if (carouselEl.swiper) return

		const slidesPerView = carouselEl.dataset.perView || 1.5
		const spaceBetween = carouselEl.dataset.spaceBetween != null
			? Number(carouselEl.dataset.spaceBetween)
			: 4
		const parent = carouselEl.parentElement
		const wrap = carouselEl.closest('.mobile-swiper-wrap')
		const progressbarEl = parent ? qs('[data-mobile-links-progressbar]', parent) : null
		const thumbsEl = wrap ? qs('[data-mobile-thumbs-carousel]', wrap) : null

		const options = {
			slidesPerView,
			spaceBetween
		}

		if (carouselEl.dataset.offsetAfter != null) {
			options.slidesOffsetAfter = Number(carouselEl.dataset.offsetAfter)
		}

		if (progressbarEl) {
			options.pagination = {
				el: progressbarEl,
				type: 'progressbar'
			}
		}

		if (thumbsEl && !thumbsEl.swiper) {
			const thumbsSpace = thumbsEl.dataset.spaceBetween != null
				? Number(thumbsEl.dataset.spaceBetween)
				: 4
			const thumbsOffsetBefore = thumbsEl.dataset.offsetBefore != null
				? Number(thumbsEl.dataset.offsetBefore)
				: 0
			const thumbsOffsetAfter = thumbsEl.dataset.offsetAfter != null
				? Number(thumbsEl.dataset.offsetAfter)
				: 0

			const thumbsSwiper = new Swiper(thumbsEl, {
				slidesPerView: 'auto',
				spaceBetween: thumbsSpace,
				slidesOffsetBefore: thumbsOffsetBefore,
				slidesOffsetAfter: thumbsOffsetAfter,
				watchSlidesProgress: true,
				watchOverflow: true
			})

			options.thumbs = {
				swiper: thumbsSwiper,
				multipleActiveThumbs: false
			}
		}

		new Swiper(carouselEl, options)
	})
}

initMobileLinksCarousel()

class ProductRecommendations extends HTMLElement {
	observer = undefined

	connectedCallback() {
		this.initializeRecommendations(this.dataset.productId)
	}

	initializeRecommendations(productId) {
		this.observer?.unobserve(this)
		this.observer = new IntersectionObserver(
			(entries, observer) => {
				if (!entries[0].isIntersecting) return
				observer.unobserve(this)
				this.loadRecommendations(productId)
			},
			{ rootMargin: '0px 0px 400px 0px' }
		)
		this.observer.observe(this)
	}

	loadRecommendations(productId) {
		fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
			.then((response) => response.text())
			.then((text) => {
				const html = document.createElement('div')
				html.innerHTML = text
				const recommendations = html.querySelector('product-recommendations')

				if (recommendations?.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML
					initMobileLinksCarousel(this)
				} else {
					this.remove()
				}
			})
			.catch((e) => {
				console.error(e)
			})
	}
}

customElements.define('product-recommendations', ProductRecommendations)

const countrySelectors = qsa('[data-country-selector-form]')

countrySelectors.forEach((section) => {
	const form = qs('form', section)
	const select = qs('select[name="country_code"]', form)

	select.addEventListener('change', (e) => {
		form.submit()
	})
})

/* Collection */

const collection = {
	grid: qs('#collection'),
	filterToggles: qsa('[data-collection-filters-toggle]'),
	filterButton: qs('#collectionFilterButton'),
	sortButton: qs('#collectionSortButton'),
	filter: qs('#collectionFilter'),
	modals: qsa('#collectionFilter [data-collection-modal]')
}

const closeCollectionModals = () => {
	if (!collection.filter) return

	collection.filter.classList.remove('active')
	collection.modals.forEach((modal) => modal.classList.remove('active'))

	if (collection.filterButton) {
		collection.filterButton.setAttribute('aria-expanded', false)
	}
	if (collection.sortButton) {
		collection.sortButton.setAttribute('aria-expanded', false)
	}
}

const openCollectionModal = (type) => {
	if (!collection.filter) return

	const modal = qs(`#collectionFilter [data-collection-modal="${type}"]`)
	if (!modal) return

	collection.modals.forEach((item) => item.classList.remove('active'))
	modal.classList.add('active')
	collection.filter.classList.add('active')

	if (collection.filterButton) {
		collection.filterButton.setAttribute('aria-expanded', type === 'filter')
	}
	if (collection.sortButton) {
		collection.sortButton.setAttribute('aria-expanded', type === 'sort')
	}
}

collection.filterToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		const type = toggle.dataset.collectionFiltersToggle
		const activeModal = qs('#collectionFilter [data-collection-modal].active')
		const isOpen = collection.filter?.classList.contains('active')

		if (!type || (isOpen && activeModal?.dataset.collectionModal === type)) {
			closeCollectionModals()
			return
		}

		openCollectionModal(type)
	})
})

/* Search Page */

const search = {
	filterToggles: qsa('[data-search-filters-toggle]'),
	filterButton: qs('#searchFilterButton'),
	sortButton: qs('#searchSortButton'),
	filter: qs('#searchFilter'),
	modals: qsa('#searchFilter [data-search-modal]')
}

const closeSearchModals = () => {
	if (!search.filter) return

	search.filter.classList.remove('active')
	search.modals.forEach((modal) => modal.classList.remove('active'))

	if (search.filterButton) {
		search.filterButton.setAttribute('aria-expanded', false)
	}
	if (search.sortButton) {
		search.sortButton.setAttribute('aria-expanded', false)
	}
}

const openSearchModal = (type) => {
	if (!search.filter) return

	const modal = qs(`#searchFilter [data-search-modal="${type}"]`)
	if (!modal) return

	search.modals.forEach((item) => item.classList.remove('active'))
	modal.classList.add('active')
	search.filter.classList.add('active')

	if (search.filterButton) {
		search.filterButton.setAttribute('aria-expanded', type === 'filter')
	}
	if (search.sortButton) {
		search.sortButton.setAttribute('aria-expanded', type === 'sort')
	}
}

search.filterToggles.forEach((toggle) => {
	toggle.addEventListener('click', () => {
		const type = toggle.dataset.searchFiltersToggle
		const activeModal = qs('#searchFilter [data-search-modal].active')
		const isOpen = search.filter?.classList.contains('active')

		if (!type || (isOpen && activeModal?.dataset.searchModal === type)) {
			closeSearchModals()
			return
		}

		openSearchModal(type)
	})
})

/* Product */

const relatedProductEls = {
	title: qs('#relatedProductsTitle'),
	products: qsa('[data-related-product-title]')
}

let active = false

relatedProductEls.products.forEach((el) => {
	const title = el.dataset.relatedProductTitle

	el.addEventListener('mouseover', (e) => {
		relatedProductEls.title.textContent = title
		relatedProductEls.title.classList.add('active')
		active = true
	})
	el.addEventListener('mouseleave', (e) => {
		relatedProductEls.title.classList.remove('active')
		setTimeout(() => {
			if (!active) {
				relatedProductEls.title.textContent = ''
			}
		}, 300)
	})
})

const lightboxes = qsa('[data-lightbox]')

lightboxes.forEach((lightbox) => {
	const id = lightbox.dataset.lightbox

	const _carousel = qs(`[data-lightbox-carousel="${id}"]`)
	const triggers = qsa(`[data-lightbox-trigger="${id}"]`)
	const closeBtns = qsa(`[data-lightbox-close="${id}"]`)

	const carousel = new Swiper(_carousel, {
		slidesPerView: 1,
		zoom: true,
		speed: 500
	})

	triggers.forEach((trigger) => {
		const idx = Number(trigger.dataset.idx)

		trigger.addEventListener('click', (e) => {
			e.preventDefault()
			lightbox.showModal()
			// Dialog was display:none at init — update before slideTo
			carousel.update()
			carousel.slideTo(idx, 0)
		})
	})

	closeBtns.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			lightbox.close()
		})
	})
})

/* Section - Text Tabs Plus Image */
const textTabsPlusImageSections = qsa('[data-text-tabs-plus-image]')

textTabsPlusImageSections.forEach((section) => {
	const tabs = qsa('[data-text-tabs-plus-image-tab]', section)
	const panels = qsa('[data-text-tabs-plus-image-panel]', section)

	const setTextTabsPlusImageTab = (tabId) => {
		tabs.forEach((tab) => {
			const isActive = tab.dataset.textTabsPlusImageTab === tabId
			tab.classList.toggle('active', isActive)
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
		})

		panels.forEach((panel) => {
			const isActive = panel.dataset.textTabsPlusImagePanel === tabId
			panel.classList.toggle('active', isActive)
			panel.hidden = !isActive
		})
	}

	tabs.forEach((tab) => {
		tab.addEventListener('click', (e) => {
			e.preventDefault()
			setTextTabsPlusImageTab(tab.dataset.textTabsPlusImageTab)
		})
	})
})

/* Product sticky ATC (mobile) */
const productStickyAtc = qs('[data-product-sticky-atc]')

if (productStickyAtc) {
	const openBtn = qs('[data-product-sticky-open]', productStickyAtc)
	const closeBtn = qs('[data-product-sticky-close]', productStickyAtc)
	const footer = qs('.footer')

	if (openBtn) {
		openBtn.addEventListener('click', () => {
			productStickyAtc.classList.add('active')
		})
	}

	if (closeBtn) {
		closeBtn.addEventListener('click', () => {
			productStickyAtc.classList.remove('active')
		})
	}

	if (footer && 'IntersectionObserver' in window) {
		const footerObserver = new IntersectionObserver(
			([entry]) => {
				productStickyAtc.classList.toggle(
					'is-footer-visible',
					entry.intersectionRatio >= 0.3
				)
			},
			{ threshold: [0, 0.3, 1] }
		)

		footerObserver.observe(footer)
	}
}
